import {environments} from '@/constants/app.js'
import {computed, ref} from 'vue'

/**
 * Environment composable
 */
export function useEnv() {

  //Origin and hostname
  const href = computed(() => window.location.href)
  const origin = computed(() => window.location.origin)
  const hostname = computed(() => window.location.hostname)
  const port = computed(() => window.location.port)

  //Determine app environment and other environment variables
  const env = ref(import.meta.env.VITE_APP_ENV)
  const gitHash = ref(import.meta.env.VITE_APP_GIT_HASH)
  const useMocks = ref(import.meta.env.VITE_USE_MOCKS === 'true')

  //Helper refs
  const isLocal = computed(() => env.value === environments.LOCAL)
  const isDev = computed(() => env.value === environments.DEV)
  const isQa = computed(() => env.value === environments.QA)
  const isStaging = computed(() => env.value === environments.STAGING)
  const isProduction = computed(() => env.value === environments.PRODUCTION)

  //Special check for Vitest and test env
  const isVitest = computed(() => typeof process !== 'undefined' ? !!process.env.VITEST : false)
  const isTest = computed(() => isVitest.value)

  //Expose interface
  return {
    env,
    href,
    origin,
    hostname,
    port,
    isLocal,
    isDev,
    isQa,
    isStaging,
    isProduction,
    isVitest,
    isTest,
    gitHash,
    useMocks,
  }
}
